import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DetailscommandeService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "detail_commande");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "detail_commande", data);
  }

  deleteData(id) {
    return this.httpClient.delete(
      environment.Localurl + "detail_commande/" + id
    );
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "detail_commande/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(
      environment.Localurl + "detail_commande/" + id,
      data
    );
  }
}
